import { useState, useEffect, useMemo, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { Form } from "antd";
import {
  createGig, createGigReset, updateJobs, updateJobsReset,
  getSearchSkills, getPersonalDetailsLocation, GetFilters,
  getJobDetail, getJobTemplates, getCompanyDetailsSuggestions,
  writeWithAi, SearchValue, nlSearchExternalClear, searchExternalUsersClear,
  fetchProjects,
} from "../../../redux/actions";
import {
  debounce, getDeepCopy, isHC, isNonHC, isRemoteJobLocation, setCookie, stripEmoji,
} from "../../../shared/helpers";
import { canUseSubscriptionFeatures, isEnterprisePlan } from "../../../shared/billing";
import { fetchProfileExperienceAPI, searchProfessionsApi } from "../../../API/API";
import history from "../../../routes/history";
import { CONTRACT_JOB, PERMANENT_JOB } from "../../../shared/constant/JobConstants";

const LOCATION_TYPE_MAP = { Onsite: "on-site", Remote: "remote", Hybrid: "hybrid" };

const stripHtml = (html) => (html || "").replace(/<[^>]*>/g, "").replace(/&nbsp;/g, " ").trim();

const BUDGET_TYPE_MAP = {
  Hour:  { BudgetTypeId: 1, BudgetTypeName: "Hour",  BudgetTypeCode: "hr"  },
  Week:  { BudgetTypeId: 2, BudgetTypeName: "Week",  BudgetTypeCode: "wk"  },
  Month: { BudgetTypeId: 3, BudgetTypeName: "Month", BudgetTypeCode: "mon" },
  Year:  { BudgetTypeId: 4, BudgetTypeName: "Year",  BudgetTypeCode: "yr"  },
  Day:   { BudgetTypeId: 5, BudgetTypeName: "Daily", BudgetTypeCode: "day" },
};

export function useCreateJobFormLogic() {
  const locationn = useLocation();
  const dispatch = useDispatch();
  const [form] = Form.useForm();

  const userProfile = JSON.parse(localStorage.getItem("userProfile"));
  const profession = userProfile?.Professions?.ProfessionCode === null
    ? "HC" : localStorage.getItem("profession");

  const FromEdit = locationn.state?.FromEdit;
  const isNotTemplate = locationn.state?.NotTemplate;
  const isCompletingIncompleteJob = !!locationn.state?.CompleteIncompleteJob;
  const fromSignUp = locationn.state?.fromSignUp;
  const preselectedProjectId = locationn.state?.projectId || null;
  const isHCUser = isHC(userProfile?.Professions?.ProfessionCode) || isHC(profession);
  const isNonHCUser = isNonHC(userProfile?.Professions?.ProfessionCode) || isNonHC(profession);
  const canUseNaturalLanguageSearch = canUseSubscriptionFeatures(userProfile);

  const [templateOpen, setTemplateOpen] = useState(true);
  const [projectOpen, setProjectOpen] = useState(!!preselectedProjectId);
  const [jobDetailsOpen, setJobDetailsOpen] = useState(false);
  const [skillsOpen, setSkillsOpen] = useState(false);


  const [jobType, _setJobType] = useState(locationn.state?.JobOrderTypeName || CONTRACT_JOB);
  const setJobType = (type) => {
    _setJobType(type);
    dispatch(getJobTemplates({ type: "saved", JobOrderTypeName: type }));
  };

  const [gigtitle, setgigtitle] = useState(FromEdit ? locationn.state?.Title || "" : "");
  const [gigduration, setgigduration] = useState(FromEdit ? locationn.state?.IdealContractLengthName || "" : "");
  const [locationValue, setLocationValue] = useState(FromEdit ? locationn.state?.Location || "" : "");
  const [locobj, setlocobj] = useState(FromEdit ? locationn.state?.locobj || null : null);
  const [workpolicy, setworkpolicy] = useState(
    FromEdit ? locationn.state?.workpolicy || locationn.state?.WorkPolicy || ""
    : isNonHCUser ? "" : " "
  );
  const [openPositions, setOpenPositions] = useState(FromEdit ? locationn.state?.openPositions || null : null);
  const [hoursPerPeriod, setHoursPerPeriod] = useState(FromEdit ? locationn.state?.BudgetMin || undefined : undefined);
  const BUDGET_TYPE_NAME_TO_OPTION = { Daily: "Day", Hour: "Hour", Week: "Week", Month: "Month", Year: "Year", Day: "Day" };
  const [hoursFrequency, setHoursFrequency] = useState(
    FromEdit && locationn.state?.BudgetType
      ? (BUDGET_TYPE_NAME_TO_OPTION[locationn.state.BudgetType] ?? locationn.state.BudgetType)
      : "Week"
  );
  const [description, setDescription] = useState(FromEdit ? stripHtml(locationn.state?.Description || "") : "");
  const [descCharCount, setDescCharCount] = useState(FromEdit ? stripHtml(locationn.state?.Description || "").length : 0);
  const [saveAsTemplate, setSaveAsTemplate] = useState(
    FromEdit ? locationn.state?.saveAsTemplate || locationn.state?.isTemplate || false : false
  );
  const [jobVisibility, setJobVisibility] = useState(
    FromEdit ? (locationn.state?.isPrivate ? "private" : "public") : "public"
  );
  const [skillDetails, setskillDetails] = useState(FromEdit ? locationn.state?.Skills || [] : []);
  const [skillValue, setskillValue] = useState("");
  const [percentage, setpercentage] = useState("");
  const [mypercent, setmypercent] = useState(0);
  const [skillerror, setskillerror] = useState(false);
  const [skillDuplicateError, setskillDuplicateError] = useState(false);
  const [skillDecimalError, setSkillDecimalError] = useState(false);
  const [skillPercentValidator, setskillPercentValidator] = useState(false);
  const [skillNameError, setSkillNameError] = useState(false);
  const [skillErrorArray, setskillErrorArray] = useState([]);
  const [addSkillInput, setAddSkillInput] = useState("block");
  const [addSkillBtn, setaddSkillBtn] = useState("none");
  const [tempskillValue, settempskillValue] = useState("");
  const [tempPercentage, setTempPercentage] = useState("");
  const [validationCheck, setValidationCheck] = useState(false);
  const [selectedProjectId, setSelectedProjectId] = useState(preselectedProjectId);
  const [pendingPublish, setPendingPublish] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [currentJobId, setCurrentJobId] = useState(null);
  const [experienceLevels, setExperienceLevels] = useState([]);
  const [experienceLevelsLoading, setExperienceLevelsLoading] = useState(true);
  const [professionTitles, setProfessionTitles] = useState([]);
  const [professionTitlesLoading, setProfessionTitlesLoading] = useState(false);
  const [titleSearchPending, setTitleSearchPending] = useState(false);
  const [skillSearchPending, setSkillSearchPending] = useState(false);
  const [locationSearchPending, setLocationSearchPending] = useState(false);
  const [locationType, setLocationType] = useState("Onsite");
  const [nlSearchText, setNlSearchText] = useState(FromEdit ? locationn.state?.nl_description || "" : "");
  const [nlAiLoading, setNlAiLoading] = useState(false);
  const [nlAiTyping, setNlAiTyping] = useState(false);
  const nlAiGeneratedTextRef = useRef("");
  const nlTypewriterRef = useRef(null);
  const editLocationTypeReadRef = useRef(false);
  const editNlDescriptionReadRef = useRef(false);

  const isNonHCUserForIndustry = isNonHC(userProfile?.Professions?.ProfessionCode) || isNonHC(profession);

  const [desiredExp, setDesiredExp] = useState(
    FromEdit ? (locationn.state?.ExperienceLevels?.map((e) => e.ExperienceLevelId) || []) : []
  );

  const [workAuthorization, setWorkAuthorization] = useState(
    FromEdit ? locationn.state?.WorkAuthorization || [] : []
  );
  const [taxTerm, setTaxTerm] = useState(
    FromEdit ? locationn.state?.IdealTerms || [] : []
  );

  const [industryDetails, setIndustryDetails] = useState(
    FromEdit
      ? (locationn.state?.Industry || []).map((i) => ({
          industryName: i.IndustryName || i.industryName,
          industryPercent: i.IndustryPercent || i.industryPercent,
          isDisable: true,
        }))
      : []
  );
  const [industryValue, setIndustryValue] = useState("");
  const [percentage2, setPercentage2] = useState("");
  const [mypercent2, setMypercent2] = useState(() => {
    if (!isNonHCUserForIndustry) return 100;
    if (FromEdit && locationn.state?.Industry?.length > 0) {
      return (locationn.state.Industry || []).reduce(
        (sum, i) => sum + (i.IndustryPercent || i.industryPercent || 0), 0
      );
    }
    return 0;
  });
  const [addIndustryInput, setAddIndustryInput] = useState("block");
  const [addIndustryBtn, setAddIndustryBtn] = useState("none");
  const [industryerror, setIndustryerror] = useState(false);
  const [industryDuplicateError, setIndustryDuplicateError] = useState(false);
  const [industryDecimalError, setIndustryDecimalError] = useState(false);
  const [industryPercentValidator, setIndustryPercentValidator] = useState(false);
  const [industryErrorArray, setIndustryErrorArray] = useState([]);
  const [tempIndustryValue, setTempIndustryValue] = useState("");
  const [tempIndustryPercent, setTempIndustryPercent] = useState("");

  const filters = useSelector((state) => state.getPersonalDetailsLocationReducer.location);
  const locationRequestLoading = useSelector((state) => state.getPersonalDetailsLocationReducer.loading);
  const locationLoading = locationSearchPending || locationRequestLoading;
  const skills = useSelector((state) => state.getSearchSkillsReducer.skills);
  const skillsRequestLoading = useSelector((state) => state.getSearchSkillsReducer.loading);
  const skillsLoading = skillSearchPending || skillsRequestLoading;
  const creditsBalance = useSelector((state) => state.plansReducer?.creditsBalance);
  const createSuccessfull = useSelector((state) => state.createGigReducer.success);
  const createGigresp = useSelector((state) => state.createGigReducer.gig);
  const loadingJobCreate = useSelector((state) => state.createGigReducer.loading);
  const updateSuccess = useSelector((state) => state.UpdateJobReducer.success);
  const loadingJobUpdate = useSelector((state) => state.UpdateJobReducer.loading);
  const templates = useSelector((state) => state.postJObReeducer.jobs);
  const templatesLoading = useSelector((state) => state.postJObReeducer.loading);
  const projects = useSelector((state) => state.fetchProjectsReducer.projects);
  const projectsLoading = useSelector((state) => state.fetchProjectsReducer.loading);
  const jobdetails = useSelector((state) => state.getJobDetailReducer.jobdetails);
  const industryDropdown = useSelector((state) => state.getCompanyDetailsReducer.dropdown);
  const industryLoading = useSelector((state) => state.getCompanyDetailsReducer.loading);
  const companyProfileResp = useSelector((state) => state.getCompanyProfileDetailsReducer?.resp);
  const companyName =
    companyProfileResp?.companyProfile?.CompanyName ||
    companyProfileResp?.Profiles?.CompanyName ||
    userProfile?.Profiles?.CompanyName ||
    "";
  const canShowProjectDetails = isEnterprisePlan(creditsBalance);

  // the write-with-ai API needs a title + location; on a 400 we send the user
  // straight to Job Details so they can see what is missing
  const sendUserToJobDetailsForAi = () => {
    setJobDetailsOpen(true);
    const missingFields = [];
    if (!gigtitle?.trim()) {
      missingFields.push({ name: "gigtitle", errors: ["Please add a job title"] });
    }
    if (locationType !== "Remote" && !locationValue?.trim()) {
      missingFields.push({ name: "locationValuee", errors: ["Please enter a job location"] });
    }
    setTimeout(() => {
      if (missingFields.length) form.setFields(missingFields);
      const section = document.getElementById("cj-job-details-section");
      if (section) section.scrollIntoView({ behavior: "smooth", block: "start" });
      const firstMissing = missingFields[0]?.name;
      if (firstMissing) {
        const input = document.getElementById(firstMissing);
        if (input) input.focus({ preventScroll: true });
      }
    }, 100);
  };

  const handleNlWriteWithAi = () => {
    if (!canUseNaturalLanguageSearch) return;
    if (nlAiLoading) return;
    setNlAiLoading(true);
    dispatch(writeWithAi({
      title: gigtitle || "",
      companyName,
      locationType: LOCATION_TYPE_MAP[locationType] || "on-site",
      city: locobj?.CityName || "",
      state: locobj?.RegionName || "",
      country: locobj?.CountryName || "",
      skills: (skillDetails || []).map((s) => s.skillName).filter(Boolean),
      prompt: nlSearchText,
      onSuccess: (data) => {
        setNlAiLoading(false);
        if (data?.data?.talentFilters) {
          localStorage.setItem("aiTalentFilters", JSON.stringify(data.data.talentFilters));
        }
        if (data?.data?.generatedText) {
          // keep the AI copy free of emoji too, so it matches what the field allows
          const fullText = stripEmoji(data.data.generatedText);
          nlAiGeneratedTextRef.current = fullText;
          setNlSearchText("");
          setNlAiTyping(true);
          if (nlTypewriterRef.current) clearInterval(nlTypewriterRef.current);
          let i = 0;
          nlTypewriterRef.current = setInterval(() => {
            i++;
            setNlSearchText(fullText.slice(0, i));
            if (i >= fullText.length) {
              clearInterval(nlTypewriterRef.current);
              setNlAiTyping(false);
            }
          }, 18);
        }
      },
      onError: () => {
        setNlAiLoading(false);
        sendUserToJobDetailsForAi();
      },
    }));
  };

  const industrydensity = useMemo(
    () => (industryDropdown?.industries || []).map((ind) => ({ value: ind.IndustryName })),
    [industryDropdown],
  );

  const locationOptions = useMemo(
    () => filters?.map((f) => ({ value: f.LocationWithCountry })) || [],
    [filters],
  );
  const skilldensity = useMemo(
    () => skills?.map((s) => ({ value: s.SkillName })) || [],
    [skills],
  );
  const titleOptions = useMemo(
    () => (gigtitle && professionTitles?.length ? professionTitles.map((t, i) => ({ value: t.title, key: i })) : []),
    [professionTitles, gigtitle],
  );

  const formInitialValues = {
    gigtitle, JobDuration: gigduration || undefined,
    desiredExp: FromEdit ? desiredExp : [],
    locationValuee: locationValue, Positions: openPositions, HoursPerPeriod: hoursPerPeriod,
    Description: description, jobVisibility,
    workpolicyy: FromEdit ? locationn.state?.workpolicy || locationn.state?.WorkPolicy || undefined : undefined,
    WorkAuthorization: FromEdit ? workAuthorization : [],
    IdealTerms: FromEdit ? taxTerm : [],
    project: preselectedProjectId || undefined,
  };

  useEffect(() => {
    fetchProfileExperienceAPI().then((res) => {
      if (res?.data) setExperienceLevels(res.data);
    }).catch(() => {}).finally(() => setExperienceLevelsLoading(false));
  }, []);

  useEffect(() => {
    dispatch(updateJobsReset());
    dispatch(GetFilters());
    dispatch(getSearchSkills());
    dispatch(getCompanyDetailsSuggestions());
    dispatch(getJobTemplates({ type: "saved", JobOrderTypeName: jobType }));

    if (FromEdit) {
      if (locationn.state?.Id) dispatch(getJobDetail(locationn.state.Id));
      if (locationValue) dispatch(getPersonalDetailsLocation(locationValue));

      const percentnum = skillDetails.reduce((sum, s) => sum + s.SkillPercent, 0);
      if (skillDetails.length > 0 && percentnum <= 100) {
        setaddSkillBtn("block");
        setAddSkillInput("none");
        setmypercent(percentnum);
      }

      const industryPercentnum = industryDetails.reduce((sum, i) => sum + i.industryPercent, 0);
      if (industryDetails.length > 0 && industryPercentnum <= 100) {
        setAddIndustryBtn("block");
        setAddIndustryInput("none");
      }
    }
  }, []);

  useEffect(() => {
    if (canShowProjectDetails) {
      dispatch(fetchProjects());
    }
  }, [canShowProjectDetails, dispatch]);

  useEffect(() => {
    if (canShowProjectDetails && preselectedProjectId) {
      setProjectOpen(true);
      setSelectedProjectId(preselectedProjectId);
    }

    if (!canShowProjectDetails) {
      setSelectedProjectId(null);
      form.setFieldsValue({ project: undefined });
    }
  }, [canShowProjectDetails, form, preselectedProjectId]);

  useEffect(() => {
    if (preselectedProjectId && Array.isArray(projects) && projects.length > 0) {
      const match = projects.find((project) => project._id === preselectedProjectId);
      if (match) {
        setSelectedProjectId(match._id);
        form.setFieldsValue({ project: match._id });
      }
    }
  }, [form, preselectedProjectId, projects]);

  useEffect(() => {
    if (jobdetails?.length > 0 && FromEdit) {
      setlocobj(jobdetails[0]?.Location);
      form.setFieldsValue({ locationValuee: jobdetails[0].Location?.LocationWithCountry });
      // The saved job carries no location type of its own, and a location is
      // required unless the job is Remote — so an empty one reads back as Remote.
      // Once only: this effect also re-runs on skill edits, and the dropdown is
      // the user's after the first read.
      if (!editLocationTypeReadRef.current) {
        editLocationTypeReadRef.current = true;
        if (isRemoteJobLocation(jobdetails[0])) {
          setLocationType("Remote");
        }
      }
      // Same once-only read for the saved AI text: after the first hydrate the
      // box belongs to the user, so re-runs must not overwrite what they typed.
      if (!editNlDescriptionReadRef.current) {
        editNlDescriptionReadRef.current = true;
        const savedNlDescription = jobdetails[0]?.nl_description;
        if (savedNlDescription) setNlSearchText(stripEmoji(savedNlDescription));
      }
    }

    if (skillDetails.length === 0) setAddSkillInput("block");

    if (createSuccessfull && pendingPublish) {
      const jobOrderId = createGigresp?.JobOrderId;
      if (jobOrderId) {
        setCurrentJobId(jobOrderId);
        dispatch(updateJobs({ ...pendingPublish, id: jobOrderId, JobOrderId: jobOrderId }));
        dispatch(createGigReset());
        setPendingPublish(null);
      }
    }

    if (updateSuccess && submitting) {
      dispatch(updateJobsReset());
      setSubmitting(false);
      setCookie("finishProfile", "true");
      const jobId = FromEdit ? locationn.state?.Id : currentJobId || createGigresp?.JobOrderId;
      setTimeout(() => {
        if (isCompletingIncompleteJob) {
          const returnTo = locationn.state?.returnTo;
          history.push(
            returnTo
              ? {
                  pathname: returnTo,
                  state: {
                    reopenPlaceBid: true,
                    reopenNonce: Date.now(),
                    completedJobId: jobId,
                    reopenBidContext: locationn.state?.reopenBidContext,
                  },
                }
              : (jobId ? { pathname: `/jobdetail/${jobId}`, state: { id: jobId } } : "/joblisting")
          );
        } else if (!FromEdit && gigtitle) {
          dispatch(SearchValue(gigtitle));
          if (canUseNaturalLanguageSearch) {
            localStorage.setItem("nlpDescription", nlSearchText);
            if (nlSearchText !== nlAiGeneratedTextRef.current) {
              localStorage.removeItem("aiTalentFilters");
            }
            if (locationType === "Remote") localStorage.removeItem("nlpJobLocation");
            else if (locationValue?.trim()) localStorage.setItem("nlpJobLocation", locationValue.trim());
          } else {
            localStorage.removeItem("nlpDescription");
            localStorage.removeItem("aiTalentFilters");
            localStorage.removeItem("nlpJobLocation");
          }
          dispatch(nlSearchExternalClear());
          dispatch(searchExternalUsersClear());
          history.push(`/query/${encodeURIComponent(gigtitle)}`);
        } else {
          history.push(jobId ? { pathname: `/jobdetail/${jobId}`, state: { id: jobId } } : "/joblisting");
        }
      }, 100);
    }
  }, [jobdetails, skillDetails, createSuccessfull, updateSuccess]); // eslint-disable-line react-hooks/exhaustive-deps



  const addSkillPercent = () => {
    const duplicateError = skillDetails.some((s) => s.skillName === skillValue);
    setskillDuplicateError(duplicateError);
    const arr = [...skillDetails, { skillName: skillValue, SkillPercent: parseInt(percentage), isDisable: true }];
    const percentnum = arr.reduce((sum, s) => sum + s.SkillPercent, 0);
    if (percentnum > 100) { setskillerror(true); setSkillNameError(!skillValue?.length); return; }
    if (percentage % 1 !== 0) { setSkillDecimalError(true); setSkillNameError(!skillValue?.length); return; }
    if (skillValue && percentage && percentage > 0 && !duplicateError) {
      setSkillDecimalError(false); setskillerror(false); setmypercent(percentnum); setskillDetails(arr);
      setskillValue(""); settempskillValue(""); setpercentage(""); setskillDuplicateError(false);
      setAddSkillInput(percentnum < 100 ? "block" : "none");
      setaddSkillBtn("none");
    }
    setSkillNameError(!skillValue?.length);
  };

  const editSkillsHandler = (index, item) => {
    setAddSkillInput("none");
    const arr = getDeepCopy(skillDetails).map((el) => ({ ...el, isDisable: true }));
    arr[index] = { skillName: item.skillName, SkillPercent: parseInt(item.SkillPercent), isDisable: false };
    setskillValue(item?.skillName || ""); setpercentage();
    setskillDetails(arr); settempskillValue(item.skillName); setTempPercentage(item.SkillPercent);
  };

  const editSkills = (index) => {
    setSkillNameError(true);
    let duplicateError = false;
    let errArr = getDeepCopy(skillErrorArray);
    const arr = getDeepCopy(skillDetails);
    const compArr = getDeepCopy(skillDetails);
    delete compArr[index];
    arr[index] = {
      skillName: skillValue.length > 0 ? skillValue : skillDetails[index].skillName,
      SkillPercent: skillDetails[index].SkillPercent, isDisable: true,
    };
    for (let i = 0; i < compArr?.length; i++) {
      if (skillValue?.length === 0 ? compArr[i]?.skillName === tempskillValue : compArr[i]?.skillName === skillValue) {
        duplicateError = true;
      }
    }
    setskillDuplicateError(duplicateError);
    const percentnum = arr.reduce((sum, s) => sum + s.SkillPercent, 0);
    if (percentnum > 100) {
      setskillerror(true); errArr[index] = true; setskillErrorArray(errArr);
    } else if (percentage !== undefined ? percentage % 1 !== 0 : tempPercentage % 1 !== 0) {
      setSkillDecimalError(true);
    } else if (
      arr[index].skillName !== "" &&
      (arr[index].skillName === tempskillValue || arr[index].skillName === skillValue) &&
      arr[index].SkillPercent !== "" && arr[index].SkillPercent > 0 && !duplicateError
    ) {
      setskillDetails(arr); errArr[index] = false; setSkillDecimalError(false);
      setskillErrorArray(errArr); setmypercent(percentnum); setskillerror(false);
      setskillValue(""); setskillDuplicateError(false); setpercentage("");
      setAddSkillInput(percentnum < 100 ? "block" : "none");
      setaddSkillBtn("none");
    }
    const nameUnchanged = skillValue?.length === 0 ? arr[index].skillName !== tempskillValue : arr[index].skillName !== skillValue;
    setSkillNameError(nameUnchanged);
  };

  const deleteSkill = (_item, index) => {
    const arr = getDeepCopy(skillDetails);
    const errArr = getDeepCopy(skillErrorArray);
    arr.splice(index, 1); errArr.splice(index, 2);
    setskillDetails(arr); setskillErrorArray(errArr);
    const newTotal = arr.reduce((sum, s) => sum + s.SkillPercent, 0);
    setmypercent(newTotal);
    setpercentage("");
    if (newTotal < 100) setAddSkillInput("block");
  };

  const addIndustryPercent = () => {
    const duplicateError = industryDetails.some((i) => i.industryName === industryValue);
    setIndustryDuplicateError(duplicateError);
    const arr = [...industryDetails, { industryName: industryValue, industryPercent: parseInt(percentage2), isDisable: true }];
    const percentnum = arr.reduce((sum, i) => sum + i.industryPercent, 0);
    if (percentnum > 100) { setIndustryerror(true); return; }
    if (percentage2 % 1 !== 0) { setIndustryDecimalError(true); return; }
    if (industryValue && percentage2 && percentage2 > 0 && !duplicateError) {
      setIndustryDecimalError(false); setIndustryerror(false); setMypercent2(percentnum); setIndustryDetails(arr);
      setIndustryValue(""); setTempIndustryValue(""); setPercentage2(""); setIndustryDuplicateError(false);
      setAddIndustryInput(percentnum < 100 ? "block" : "none");
      setAddIndustryBtn("none");
    }
  };

  const editIndustryHandler = (index, item) => {
    setAddIndustryInput("none");
    const arr = getDeepCopy(industryDetails).map((el) => ({ ...el, isDisable: true }));
    arr[index] = { industryName: item.industryName, industryPercent: parseInt(item.industryPercent), isDisable: false };
    setIndustryValue(item?.industryName || ""); setPercentage2("");
    setIndustryDetails(arr); setTempIndustryValue(item.industryName); setTempIndustryPercent(item.industryPercent);
  };

  const editIndustry = (index) => {
    let duplicateError = false;
    let errArr = getDeepCopy(industryErrorArray);
    const arr = getDeepCopy(industryDetails);
    const compArr = getDeepCopy(industryDetails);
    delete compArr[index];
    arr[index] = {
      industryName: industryValue.length > 0 ? industryValue : industryDetails[index].industryName,
      industryPercent: industryDetails[index].industryPercent, isDisable: true,
    };
    for (let i = 0; i < compArr?.length; i++) {
      if (industryValue?.length === 0 ? compArr[i]?.industryName === tempIndustryValue : compArr[i]?.industryName === industryValue) {
        duplicateError = true;
      }
    }
    setIndustryDuplicateError(duplicateError);
    const percentnum = arr.reduce((sum, i) => sum + i.industryPercent, 0);
    if (percentnum > 100) {
      setIndustryerror(true); errArr[index] = true; setIndustryErrorArray(errArr);
    } else if (percentage2 !== undefined ? percentage2 % 1 !== 0 : tempIndustryPercent % 1 !== 0) {
      setIndustryDecimalError(true);
    } else if (
      arr[index].industryName !== "" &&
      (arr[index].industryName === tempIndustryValue || arr[index].industryName === industryValue) &&
      arr[index].industryPercent !== "" && arr[index].industryPercent > 0 && !duplicateError
    ) {
      setIndustryDetails(arr); errArr[index] = false; setIndustryDecimalError(false);
      setIndustryErrorArray(errArr); setMypercent2(percentnum); setIndustryerror(false);
      setIndustryValue(""); setIndustryDuplicateError(false); setPercentage2("");
      setAddIndustryInput(percentnum < 100 ? "block" : "none");
      setAddIndustryBtn("none");
    }
  };

  const deleteIndustry = (_item, index) => {
    const arr = getDeepCopy(industryDetails);
    const errArr = getDeepCopy(industryErrorArray);
    arr.splice(index, 1); errArr.splice(index, 2);
    setIndustryDetails(arr); setIndustryErrorArray(errArr);
    const newTotal = arr.reduce((sum, i) => sum + i.industryPercent, 0);
    setMypercent2(newTotal);
    setPercentage2("");
    if (newTotal < 100) setAddIndustryInput("block");
  };

  const onSelectLocation = (value) => {
    setLocationValue(value);
    dispatch(getPersonalDetailsLocation(value));
    const match = filters?.find((f) => f?.LocationWithCountry === value);
    if (match) setlocobj(match);
  };

  const debouncedSkillSearch = useMemo(
    () => debounce((val) => {
      if (!val) return;
      dispatch(getSearchSkills({ search: val, id: isNonHCUser ? 1 : 3 }));
      setTimeout(() => setSkillSearchPending(false), 0);
    }),
    [isNonHCUser],
  );

  const getSearchSkillsHandler = (e) => {
    const value = e.target.value.trim();
    settempskillValue(e.target.value);
    setSkillSearchPending(Boolean(value));
    debouncedSkillSearch(value);
  };

  const debouncedTitleSearch = useMemo(
    () => debounce(async (val) => {
      if (!val) return;
      setProfessionTitlesLoading(true);
      setTitleSearchPending(false);
      try {
        const res = await searchProfessionsApi(val);
        const raw = res?.data?.data?.results ?? res?.data?.results ?? [];
        setProfessionTitles(Array.isArray(raw) ? raw.filter(Boolean) : []);
      } catch {
        setProfessionTitles([]);
      } finally {
        setProfessionTitlesLoading(false);
      }
    }),
    [],
  );

  const handleTitleSearch = (val) => {
    const value = val.trim();
    setTitleSearchPending(Boolean(value));
    if (!value) {
      setProfessionTitles([]);
      setProfessionTitlesLoading(false);
    }
    debouncedTitleSearch(value);
  };

  const debouncedLocationSearch = useMemo(
    () => debounce((val) => {
      if (!val) return;
      dispatch(getPersonalDetailsLocation(val));
      setTimeout(() => setLocationSearchPending(false), 0);
    }),
    [],
  );

  const handleLocationSearch = (val) => {
    const value = val.trim();
    setLocationSearchPending(Boolean(value));
    debouncedLocationSearch(value);
  };

  const handleTemplateSelect = (jobOrderId) => {
    const template = templates?.find((t) => t.JobOrderId === jobOrderId);
    if (!template) return;
    const title = template.Title || "";
    const duration = template.IdealContractLength?.IdealContractLengthName || "";
    const desc = stripHtml(template.Description || "");
    const positions = template.Position || 1;
    const hours = template.BudgetMin || undefined;
    const workPol = template.WorkplacePolicy || (isNonHCUser ? "" : " ");
    setgigtitle(title); setgigduration(duration); setDescription(desc);
    setDescCharCount(desc.length); setOpenPositions(positions);
    setHoursPerPeriod(hours); setworkpolicy(workPol);
    const mappedSkills = (template.JobOrders_Skills || []).map((s) => ({
      skillName: s?.Skills?.SkillName || s?.skillName || "",
      SkillPercent: s.SkillPercent, isDisable: true,
    }));
    setskillDetails(mappedSkills);
    const totalPct = mappedSkills.reduce((sum, s) => sum + s.SkillPercent, 0);
    setmypercent(totalPct);
    setAddSkillInput("none");
    setaddSkillBtn(totalPct >= 100 ? "none" : "block");
    const exp = template.ExperienceLevels?.map((e) => e.ExperienceLevelId) || [];
    setDesiredExp(exp);
    const workAuth = template.WorkAuthorization || [];
    setWorkAuthorization(workAuth);
    const idealTerms = template.IdealTerms || [];
    setTaxTerm(idealTerms);

    const mappedIndustries = (template.Industry || []).map((i) => ({
      industryName: i.IndustryName || i.industryName,
      industryPercent: i.IndustryPercent || i.industryPercent,
      isDisable: true,
    }));
    setIndustryDetails(mappedIndustries);
    const industryTotal = mappedIndustries.reduce((sum, i) => sum + i.industryPercent, 0);
    setMypercent2(industryTotal);
    if (mappedIndustries.length > 0) {
      setAddIndustryInput("none");
      setAddIndustryBtn(industryTotal < 100 ? "block" : "none");
    }

    const locationStr = template.Cities?.CityName && template.Regions?.Code
      ? `${template.Cities.CityName}, ${template.Regions.Code}` : "";
    if (locationStr) {
      setLocationValue(locationStr);
      setlocobj({
        CityId: template.Cities.CityId, CityName: template.Cities.CityName,
        CountryId: template.Countries?.CountryId, CountryName: template.Countries?.CountryName,
        RegionCode: template.Regions.Code, RegionId: template.Regions.RegionId,
        RegionName: template.Regions.RegionName, LocationWithCountry: locationStr,
      });
    }
    form.setFieldsValue({
      gigtitle: title, JobDuration: duration || undefined, Description: desc,
      Positions: positions, HoursPerPeriod: hours, workpolicyy: workPol || undefined,
      locationValuee: locationStr || undefined,
      desiredExp: exp,
      WorkAuthorization: workAuth,
      IdealTerms: idealTerms,
    });
  };


  const handlePublish = async () => {
    try {
      let errorCheck = false;
      setValidationCheck(true);
      await form.validateFields().catch(() => { errorCheck = true; });
      if (mypercent !== 100) { setskillPercentValidator(true); return; }
      if (isNonHCUser && industryDetails.length > 0 && mypercent2 !== 100) { setIndustryPercentValidator(true); return; }
      if (!gigtitle?.trim().length || !desiredExp?.length || errorCheck) return;
      const secondStepData = {
        Description: description, Position: openPositions,
        BudgetMin: hoursPerPeriod,
        BudgetTypes: BUDGET_TYPE_MAP[hoursFrequency] ?? null,
        BudgetTypeName: BUDGET_TYPE_MAP[hoursFrequency]?.BudgetTypeName ?? hoursFrequency,
        BudgetTypeCode: BUDGET_TYPE_MAP[hoursFrequency]?.BudgetTypeCode ?? hoursFrequency?.toLowerCase(),
        isTemplate: saveAsTemplate,
        templateType: saveAsTemplate ? "saved" : null,
        JobOrderStatusName: "Published", isPrivate: jobVisibility === "private",
      };
      setSubmitting(true);
      const isPermanent = jobType === PERMANENT_JOB;
      const locationPayload = workpolicy !== "fully-remote" ? locobj : null;
      const industryPayload = industryDetails.map((i) => ({
        IndustryName: i.industryName,
        IndustryPercent: i.industryPercent,
        isDisable: true,
      }));
      const sharedFields = {
        Title: gigtitle, JobOrders_Skills: skillDetails,
        IdealContractLengthName: isPermanent ? null : gigduration,
        Location: locationPayload, ExperienceLevelId: desiredExp,
        Industry: industryPayload,
        JobOrderTypeName: jobType, WorkplacePolicy: workpolicy,
        WorkAuthorization: workpolicy !== "fully-remote" ? workAuthorization : null,
        IdealTerms: taxTerm,
        nl_description: nlSearchText,
      };
      const projectPayload =
        canShowProjectDetails && selectedProjectId
          ? { ProjectId: selectedProjectId }
          : {};
      if (FromEdit && isNotTemplate) {
        dispatch(updateJobs({
          ...sharedFields,
          id: locationn.state?.Id, ...secondStepData,
          ...projectPayload,
        }));
      } else {
        setPendingPublish({ ...secondStepData, Location: locationPayload, IdealTerms: taxTerm, nl_description: nlSearchText });
        dispatch(createGig({
          ...sharedFields,
          JobOrderStatusName: "Draft",
          ...projectPayload,
        }));
      }
    } catch {
      setSubmitting(false);
    }
  };

  const isPublishEnabled = useMemo(() => {
    const hasTitle = !!gigtitle?.trim().length;
    const hasDuration = jobType === PERMANENT_JOB || !!gigduration;
    const hasDesiredExp = desiredExp?.length > 0;
    const hasLocation = workpolicy === "fully-remote" || !!locationValue;
    const hasWorkPolicy = !isHCUser || !!workpolicy?.trim();
    const hasPositions = openPositions !== null && openPositions !== undefined;
    const hasDescription = !!stripHtml(description).trim().length;
    const hasSkills = mypercent === 100;
    const hasValidIndustry = !isNonHCUser || industryDetails.length === 0 || mypercent2 === 100;
    const hasWorkAuth = workpolicy === "fully-remote" || workAuthorization?.length > 0;
    const hasTaxTerm = taxTerm?.length > 0;
    return hasTitle && hasDuration && hasDesiredExp && hasLocation && hasWorkPolicy && hasPositions && hasDescription && hasSkills && hasValidIndustry && hasWorkAuth && hasTaxTerm;
  }, [gigtitle, gigduration, jobType, desiredExp, locationValue, workpolicy, isNonHCUser, openPositions, description, mypercent, industryDetails, mypercent2, workAuthorization, taxTerm]);

  return {
    form, formInitialValues, FromEdit, isCompletingIncompleteJob, fromSignUp, isHCUser, isNonHCUser,
    templateOpen, setTemplateOpen, projectOpen, setProjectOpen,
    jobDetailsOpen, setJobDetailsOpen, skillsOpen, setSkillsOpen,
    jobType, setJobType,
    gigtitle, setgigtitle, gigduration, setgigduration,
    locationValue, setLocationValue, locobj, workpolicy, setworkpolicy,
    openPositions, setOpenPositions, hoursPerPeriod, setHoursPerPeriod,
    hoursFrequency, setHoursFrequency, description, setDescription,
    descCharCount, setDescCharCount, saveAsTemplate, setSaveAsTemplate,
    jobVisibility, setJobVisibility,
    desiredExp, setDesiredExp, experienceLevels, experienceLevelsLoading,
    workAuthorization, setWorkAuthorization,
    taxTerm, setTaxTerm,
    skillDetails, setskillDetails, skillValue, setskillValue, tempskillValue, settempskillValue,
    percentage, setpercentage, mypercent, skillerror, skillDuplicateError,
    skillDecimalError, skillPercentValidator, skillNameError, skillErrorArray,
    addSkillInput, setAddSkillInput, addSkillBtn, setaddSkillBtn,
    industryDetails, setIndustryDetails, industryValue, setIndustryValue,
    percentage2, setPercentage2, mypercent2,
    addIndustryInput, setAddIndustryInput, addIndustryBtn, setAddIndustryBtn,
    industryerror, industryDuplicateError, industryDecimalError,
    industryPercentValidator, industryErrorArray,
    industrydensity,
    skilldensity, skillsLoading, titleOptions,
    titleLoading: titleSearchPending || professionTitlesLoading,
    locationOptions, locationLoading,
    templates, templatesLoading, projects, projectsLoading, filters,
    industryLoading, validationCheck, setValidationCheck,
    canShowProjectDetails,
    isLoading: (loadingJobCreate || loadingJobUpdate) && submitting,
    isPublishEnabled, selectedProjectId, setSelectedProjectId,
    addSkillPercent, editSkillsHandler, editSkills, deleteSkill,
    addIndustryPercent, editIndustryHandler, editIndustry, deleteIndustry,
    onSelectLocation, getSearchSkillsHandler, handleTitleSearch, handleLocationSearch,
    handleTemplateSelect, handlePublish,
    locationType, setLocationType, nlSearchText, setNlSearchText,
    nlAiLoading, nlAiTyping, handleNlWriteWithAi,
  };
}
